module.exports = __webpack_public_path__ + "img/samsung.5c921e82.png";